// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b2bce621","247":"4809e20c","422":"23b90915","627":"03be0125","653":"a553098f","867":"3cf6a33c","923":"c4164064","938":"dffe096e"}[chunkId] + ".chunk.js";
};